/**
 * Mock responses for ROI Calculator APIs.
 * Used when REACT_APP_USE_CALCULATOR_MOCK=true or when API is unavailable.
 */

export const mockConfigResponse = {
  employees: { min: 50, max: 300, default: 120 },
  phases: [
    { id: 1, label: 'Standard', title: 'Phase 1 — Standard Launch', body: 'Attendance gateway, registration bonus, excellence recognition, anniversaries, and birthdays. Everything runs automatically once the data integration is live.' },
    { id: 2, label: 'Performance', title: 'Phase 2 — Performance Layer', body: 'Adds productivity and KPI incentives. Requires deeper EHR data. The full gateway mechanic activates here — behavioral change accelerates.' },
    { id: 3, label: 'Optimized', title: 'Phase 3 — Optimized', body: 'Client tunes coin values based on their own behavioral data. Fully customized. This is the model that drives 3.4x lower call-offs and 6.9x higher productivity.' },
  ],
  incentives: [
    { id: 'attendance', name: 'Perfect Attendance', description: 'Per pay period with zero call-offs', isGateway: true, defaultCoins: 200 },
    { id: 'registration', name: 'Registration Bonus', description: 'One-time award for downloading the app', isGateway: false, defaultCoins: 167 },
    { id: 'excellence', name: 'Excellence Recognition', description: 'Manager recognition for outstanding care', isGateway: false, defaultCoins: 100 },
    { id: 'productivity', name: 'Productivity / KPI', description: 'Performance metrics (documentation, tasks)', isGateway: false, defaultCoins: 150 },
    { id: 'anniversary', name: 'Work Anniversary', description: 'Annual milestone celebration', isGateway: false, defaultCoins: 333 },
    { id: 'birthday', name: 'Birthday Recognition', description: 'Annual personal milestone reward', isGateway: false, defaultCoins: 167 },
  ],
  globals: {
    coinValueDollars: 0.03,
    platformFeePerEmployee: 4,
  },
};

/**
 * Phase ID to default enabled incentives (phase 1 = no productivity, phase 2/3 = all).
 */
export const getDefaultTogglesForPhase = (phaseId) => {
  const base = { attendance: true, registration: true, excellence: true, anniversary: true, birthday: true };
  if (phaseId === 1) return { ...base, productivity: false };
  return { ...base, productivity: true };
};

export const mockCalculateResponse = {
  platformFee: 480,
  monthlyRewards: 832,
  totalMonthlyCost: 1312,
  annualCost: 15744,
  monthlySavings: 11333,
  annualSavings: 135996,
  roi: 9,
  breakEvenDays: 35,
  calloffSavings: 7903,
  turnoverSavings: 3430,
  productivitySavings: 0,
};
